import { SortItem } from '../ss-api/responses/member.dashboard.license.response';

interface WMIItem {
    Key: string;
    Value: string;
}

export class WMIItemArray extends Array<WMIItem> {
    public LastSort = new SortItem;

    constructor(...items: WMIItem[]) {
        super(...items);
        Object.setPrototypeOf(this, WMIItemArray.prototype);
    }
}

export class LiveHubWMIBrowseResponse {
    ErrorMessage: string;
    IsError: boolean;
    LicenseKey: string;
    MaxResults: number;
    Offset: number;
    RequestMethod: string;
    Result: WMIItemArray;
}
